import React, { useEffect, useMemo, useState } from "react";
import { CircularProgress, DialogContent, DialogTitle, List, ListItem, TableCell, Typography } from "@material-ui/core";
import Table from "@material-ui/core/Table";
import TableHead from "@material-ui/core/TableHead";
import TableRow from "@material-ui/core/TableRow";
import TableBody from "@material-ui/core/TableBody";
import GetCurrency from "../../helper/GetCurrency";
import { _get } from "../../Api";
import { toast } from "react-toastify";

function DetailedOrder({ order }) {
  const isTakeaway = order.ordergroupable.receipt_type === "TAKEAWAY";
  const isDelivery = order.ordergroupable.receipt_type === "DELIVERY";
  const isInhouse = order.ordergroupable.sp_receipt_id > 0;
  const isPillar = order.ordergroupable.pillar_device_id > 0;
  const jsonContactInformation = order.ordergroupable?.contact_information
    ? JSON.parse(order.ordergroupable?.contact_information)
    : [];
  const [ordergroup, setOrdergroup] = useState(null);

  const totalItemCost = useMemo(() => {
    let totalCost = 0
    if (ordergroup) {
      ordergroup.o_m_articles.forEach((OMArticle) => {
        totalCost += OMArticle.total_cost;
      })
    }
    return totalCost;
  },[ordergroup])

  useEffect(() => {
    getOrder(order.id).then((data) => {
      setOrdergroup(data?.ordergroup ?? null);
    });
  }, []);

  console.log(ordergroup);

  return (
    <>
      <DialogTitle>
        <Typography variant={"h5"}>
          {isTakeaway ? "Takeaway Order - T" + order.ordergroupable.number : null}
          {isDelivery ? "Delivery Order - T" + order.ordergroupable.number : null}
          {isInhouse ? "Inhouse Order - " + order.ordergroupable.sp_receipt.table_id : null}
          {isPillar ? "Kiosk Order" : null}
        </Typography>
      </DialogTitle>
      <DialogContent>
        {isTakeaway || isDelivery ? (
          <Table>
            <TableHead style={{ fontWeight: 800 }}>
              <TableRow style={{ fontWeight: 800 }}>
                <TableCell>ID</TableCell>
                <TableCell>Merchant</TableCell>
                <TableCell>Table ID</TableCell>
                <TableCell>Contact information</TableCell>
                <TableCell>Payment method</TableCell>
                <TableCell>Status</TableCell>

                <TableCell>Total of items</TableCell>
                <TableCell>Transaction fee</TableCell>
                <TableCell>Delivery fee</TableCell>
                <TableCell>Tip fee</TableCell>
                <TableCell>Total</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              <TableRow>
                <TableCell>{order.id}</TableCell>
                <TableCell>{order.merchant.name}</TableCell>
                <TableCell>{order.ordergroupable.table_id}</TableCell>
                <TableCell>
                  <List dense>
                    {Object.keys(jsonContactInformation).map((key) => (
                      <ListItem>
                        {key}: {jsonContactInformation[key]}
                      </ListItem>
                    ))}
                  </List>
                </TableCell>
                <TableCell>{order.ordergroupable.payment_method}</TableCell>
                <TableCell>{order.ordergroupable.status}</TableCell>
                <TableCell>
                  {GetCurrency(order.merchant.currency)} {(totalItemCost / 100.0).toFixed(2)}
                </TableCell>
                <TableCell>
                  {GetCurrency(order.merchant.currency)} {(order.ordergroupable.extra_payment_costs / 100.0).toFixed(2)}
                </TableCell>
                <TableCell>
                  {GetCurrency(order.merchant.currency)}{" "}
                  {(order.ordergroupable.extra_delivery_costs / 100.0).toFixed(2)}
                </TableCell>
                <TableCell>
                  {GetCurrency(order.merchant.currency)} {(order.tip_amount / 100.0).toFixed(2)}
                </TableCell>
                <TableCell>
                  {GetCurrency(order.merchant.currency)}{" "}
                  {(
                    (totalItemCost +
                      order.ordergroupable.extra_payment_costs +
                      order.ordergroupable.extra_delivery_costs +
                      order.tip_amount) /
                    100.0
                  ).toFixed(2)}
                </TableCell>
              </TableRow>
            </TableBody>
          </Table>
        ) : null}
        {isInhouse ? (
          <Table>
            <TableHead style={{ fontWeight: 800 }}>
              <TableRow>
                <TableCell>ID</TableCell>
                <TableCell>Merchant</TableCell>
                <TableCell>Table ID</TableCell>
                <TableCell>Status</TableCell>
                <TableCell>Total cost of items</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              <TableRow>
                <TableCell>{order.id}</TableCell>
                <TableCell>{order.merchant.name}</TableCell>
                <TableCell>{order.ordergroupable.sp_receipt.table_id}</TableCell>
                <TableCell>{order.ordergroupable.sp_receipt.status}</TableCell>
                <TableCell>{GetCurrency(order.merchant.currency)}{" "}
                  {(totalItemCost / 100.0).toFixed(2)}</TableCell>
              </TableRow>
            </TableBody>
          </Table>
        ) : null}

        <Typography variant={"h6"}>Articles</Typography>
        {ordergroup == null ? <CircularProgress/> :<Table>
          <TableHead style={{ fontWeight: 800 }}>
            <TableRow>
              <TableCell>ID</TableCell>
              <TableCell>Name</TableCell>
              <TableCell>Count</TableCell>
              <TableCell>Total amount</TableCell>
              <TableCell>Options</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {ordergroup?.o_m_articles.map((omarticle) => (
              <TableRow>
                <TableCell>{omarticle.id}</TableCell>
                <TableCell>{omarticle.name}</TableCell>
                <TableCell>{omarticle.amount} x</TableCell>
                <TableCell>
                  {GetCurrency(order.merchant.currency)} {(omarticle.total_cost / 100.0).toFixed(2)}
                </TableCell>
                <TableCell>
                  <List dense>
                    {omarticle.o_m_modifiergroups?.reduce((lines, ommodifiergroup) => {
                      if (ommodifiergroup.o_m_modifierarticles) {
                        ommodifiergroup.o_m_modifierarticles.forEach((ommodifierarticle) => {
                          lines.push(
                            <ListItem>
                              {ommodifierarticle.amount} x {ommodifierarticle.name} -{" "}
                              {GetCurrency(order.merchant.currency)} {(ommodifierarticle.price / 100.0).toFixed(2)} p.u.
                              <br />
                              {GetCurrency(order.merchant.currency)}{" "}
                              {((ommodifierarticle.price * ommodifierarticle.amount) / 100.0).toFixed(2)} total
                            </ListItem>
                          );
                        });
                      }
                      return lines;
                    }, [])}
                  </List>
                </TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>}
      </DialogContent>
    </>
  );
}

function getOrder(orderId) {
  return _get(`/nova/v2/ordergroups/${orderId}`)
    .then((res) => {
      return Promise.resolve(res.data);
    })
    .catch((e) => {
      toast.error("Something went wrong.", {
        position: "bottom-right",
        autoClose: 2000,
        hideProgressBar: true,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined
      });
    });
}


export default DetailedOrder;
